import expireMate from "../../assets/indieapps/expire-mate.png";

export const DataIndieApps = [
  {
    image: expireMate,
    url: 'https://expire-mate.faizmdf.web.id'
  },
];
